export default function Features() {
  const features = [
    {
      title: '無料10分診断（原因の切り分け）',
      points: [
        '離脱ポイント / 伝達不足 / 計測不備を確認',
        '改善の優先順位を提示'
      ]
    },
    {
      title: 'LP・導線の改善設計',
      points: [
        '症状訴求（刺さる冒頭）に変換',
        'オファー設計（無料診断/資料/チェックリスト等）',
        'CTA位置・文言・フォーム最適化'
      ]
    },
    {
      title: '計測と検証（無駄撃ち回避）',
      points: [
        'CV計測（GA4/Google広告）確認',
        '検索広告で"悩みキーワード"を検証',
        '成果が出た要素を拡張'
      ]
    }
  ];

  return (
    <section id="features" className="py-20 md:py-28 bg-white">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black text-gray-900 mb-4">
            Autopilot がやること<br />
            <span className="text-2xl md:text-3xl text-gray-600">（問い合わせ増加の最短ルート）</span>
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            "原因特定 → 優先順位 → 改修 → 少額広告検証 → 数字で改善" を一気通貫で。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature, index) => (
            <div key={index} className="bg-gray-50 p-8 rounded-xl hover:shadow-lg transition-shadow">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-lg mb-6">
                <span className="text-white text-xl font-black">{index + 1}</span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 leading-tight">{feature.title}</h3>
              <ul className="space-y-3">
                {feature.points.map((point, idx) => (
                  <li key={idx} className="flex items-start gap-2">
                    <div className="w-4 h-4 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-arrow-right-s-line text-gray-700 text-lg"></i>
                    </div>
                    <span className="text-sm text-gray-600 leading-relaxed">{point}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
